import { z } from 'zod'

export interface ShipmentFormData {
  trailer: string
  source: string
  sourceId: string
  tags: string[]
  shipDate?: Date
  pickupDate?: Date
  deliveryDate?: Date
  loadBoardNote: string
  customerNote: string
}

export const EMPTY_SHIPMENT_DEFAULTS: ShipmentFormData = {
  trailer: '',
  source: '',
  sourceId: '',
  tags: [],
  shipDate: undefined,
  pickupDate: undefined,
  deliveryDate: undefined,
  loadBoardNote: '',
  customerNote: '',
}

export function useShipmentSchema(requireDates = false) {
  const dateField = requireDates ? z.date() : z.date().optional()
  return z.object({
    trailer: z.string().optional().default(''),
    source: z.string().optional().default(''),
    sourceId: z.string().optional().default(''),
    tags: z.array(z.string()).optional().default([]),
    shipDate: dateField,
    pickupDate: dateField,
    deliveryDate: dateField,
    loadBoardNote: z.string().optional().default(''),
    customerNote: z.string().optional().default(''),
  })
}
